import GenericDb from './genericDb'

export default () => GenericDb('alias')